import * as React from "react";
import { merge } from "glamor";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Dialog from "components/dialog/dialog";
import Button from "components/form/button";
import { format } from "lib/globalize-util";
import theme from "styles/theme";
import WarningIcon from "@material-ui/icons/ErrorOutline";

interface IProps {
    open: boolean;
    onRequestClose: () => void;
    onConfirm: () => void;
    onCancel: () => void;
    // TODO: UNUSED
    shipDate: any;
}

const DeleteDateWarning: React.FC<IProps> = (props) => {
    const { open, onRequestClose, onConfirm, onCancel } = props;

    const styles = React.useMemo(
        () => ({
            body: {
                overflow: "unset",
                paddingTop: "18px",
                color: theme.palette.textColor,
            },
            contentStyle: {
                minWidth: "200px",
            },
            actionsContainerStyle: {
                display: "flex",
                justifyContent: "flex-end",
            },
            btnYes: {
                marginLeft: "10px",
            },
        }),
        [],
    );

    const contentStyles = React.useMemo(() => {
        return {
            titleIcon: merge({
                fontSize: "1.8rem !important",
                marginRight: "8px",
            }),
        };
    }, []);

    return (
        <MuiThemeProvider muiTheme={theme}>
            <Dialog
                title={
                    <div>
                        <WarningIcon htmlColor={theme.palette.error} className={`${contentStyles.titleIcon}`} />
                        {format("Remove shipment with product(s)?")}
                    </div>
                }
                open={open}
                onRequestClose={onRequestClose}
                contentStyle={styles.contentStyle}
                actionsContainerStyle={styles.actionsContainerStyle}
                bodyStyle={styles.body}
                actions={[
                    <Button key="no" label={format("Cancel")} onClick={onCancel} />,
                    <Button
                        key="yes"
                        label={format("Remove")}
                        style={styles.btnYes}
                        onClick={onConfirm}
                        primary={true}
                    />,
                ]}
            >
                <div>
                    {format("Removing this shipment will also remove the product(s) included in it from your order.")}
                </div>
            </Dialog>
        </MuiThemeProvider>
    );
};

export default DeleteDateWarning;
